'use client'

import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/react'
import { ChevronDownIcon } from '@heroicons/react/24/solid'
import type React from 'react'
import { cn } from '../../shared/cn'

export function Accordion({
  children,
  title,
  onToggle,
  className,
  defaultOpen = false
}: {
  children: React.ReactNode
  title: React.ReactNode
  onToggle?: (open: boolean) => void
  className?: string
  defaultOpen?: boolean
}) {
  return (
    <Disclosure as='div' defaultOpen={defaultOpen}>
      {({ open }) => (
        <div>
          <DisclosureButton
            type='button'
            onClick={() => onToggle?.(!open)}
            className={cn('flex w-full cursor-pointer items-center justify-between', className)}
          >
            {title}
            <ChevronDownIcon
              aria-hidden='true'
              className={cn(
                'h-4 w-4 shrink-0 text-contentPrimary transition-transform duration-300 ease-out motion-reduce:transition-none',
                open && 'rotate-180'
              )}
            />
          </DisclosureButton>
          <DisclosurePanel className='pt-4 text-contentPrimary'>{children}</DisclosurePanel>
        </div>
      )}
    </Disclosure>
  )
}
